module.exports = __webpack_public_path__ + "img/plan_nb.7903987c.jpg";